import LayoutFactory from "../../../../../../components/LayoutFactory/component";
import { getPlaceholderItems } from "../../../../../../components/LayoutFactory/component";
import { DISCOVERY_LAYOUT } from "./constants";
import { CardVariantsEnum } from "../../../../../../utils/dataTransform/ContentQueryWidget/types";

const DetailDiscoveryPlaceholder = ({ numLoadingCards }) => {
    return (
        <div
            className="detailDiscovery-placeholder"
            data-testid="detailDiscovery-placeholder"
        >
            <div className="detailDiscovery-placeholder-headline" />
            <LayoutFactory
                layout={DISCOVERY_LAYOUT}
                items={getPlaceholderItems(
                    numLoadingCards,
                    CardVariantsEnum.DISCOVERY
                )}
            />
        </div>
    );
};

export default DetailDiscoveryPlaceholder;
